export default "__VITE_ASSET__BsxZ$avC__"